module.exports = __webpack_public_path__ + "media/snap.bb33d430.mp3";